<template>
  <div class="home">
    <div class="grant2">
      <div class="grant_W">
        <div class="Applic">
          <div class="title">TFSC <span>Fundraising</span></div>
          <div class="contents">
            <div>
              Welcome to participate in the fundraising of the TFSC . TFSC is a
              fully decentralized public chain, where anyone can read, send, and
              confirm transactions and participate in it. TFSC is characterized
              by its ability to enable multiple block producers to process
              blocks in parallel through a lightweight Raindrop Consensus
              Protocol and a special chain structure, making it highly scalable
              and performant.
            </div>

            <div class="content2">
              In order to further promote the development of the TFSC , we will
              conduct fundraising, where 20% of the initial issuance will be
              used for fundraising. We hope to achieve faster development and
              better results for the TFSC through your participation and
              support.
            </div>
            <div class="content2">
              We need a purer WEB3 spirit. We don't want to see monopoly or
              kidnapping that deviates from everyone's thinking. In the wave of
              web3 development, we need more strategic partners with
              decentralized thinking to achieve the ultimate goal of TFSC
              together.
            </div>
          </div>
          <div class="follows">
            The basic for the fundraising is as follows:
          </div>
          <div class="followsbox">
            <div class="follows_l">
              <div class="folltitle">
                Fundraising round: <span>Seed round </span>
              </div>
              <div class="follcont_box">
                <div class="follcont">Seed round quota: <span>8%</span></div>
                <div class="follcont">
                  Minimum subscription amount: <span> 50,000U </span>
                </div>
                <div class="follcont">
                  Subscription deadline: <span>May 31, 2023</span>
                </div>
                <div class="follcont">
                  Fundraising price: <span> 0.7U/TFSC</span>
                </div>
                <div class="follcont">
                  Release ratio:
                  <span>
                    Linear release within one year after the mainnet
                    launch</span
                  >
                </div>
              </div>
              <div class="links">
                <div class="linkst" @click="goPage('/pc/Applicationd')">
                  View the tokenomics of TFSC<img
                    src="../../assets/pc/Appction/link.png"
                  />
                </div>
                <div class="follbtn" @click="goPage('/pc/Applicationa')">
                  Apply now
                </div>
              </div>
            </div>
            <div class="follows_r">
              <div class="folltitle">
                Fundraising round: <span> Institutional round </span>
              </div>
              <div class="follcont_box">
                <div class="follcont">
                  Institutional round quota: <span>12%</span>
                </div>
                <div class="follcont">
                  Minimum subscription amount: <span>TBA</span>
                </div>
                <div class="follcont">
                  Subscription deadline:<span> TBA</span>
                </div>
                <div class="follcont">Fundraising price: <span>TBA</span></div>
                <div class="follcont">Release ratio: <span>TBA</span></div>
              </div>
              <div class="links">
                <div class="linkst" @click="goPage('/pc/Applicationd')">
                  View the tokenomics of TFSC<img
                    src="../../assets/pc/Appction/link.png"
                  />
                </div>
                <div class="follbtn">Not yet started</div>
              </div>
              <!-- <div class="follbtn">Not yet started</div> -->
            </div>
          </div>
          <div class="email">
            Contact email:<span> invest-info@tfsc.io</span>
          </div>
          <div class="email1">
            If you are interested in the TFSC or have any questions, please feel
            free to contact us via the email above.
          </div>
          <div class="email2">
            We firmly believe that TFSC will be an important component of future
            blockchain technology. If you are interested in this project, we
            sincerely invite you to participate in our fundraising campaign and
            witness the ultimate goal of TFSC together!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      swiperOption: {
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 30,
        // setWrapperSize: true,
        mousewheel: true,
        autoHeight: true,
        height: window.innerHeight,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    goPage(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang="less" scoped>
.el-input__wrapper {
  border: none !important;

  box-shadow: none !important;

  padding: 0px; //前边边距去掉
}

.home {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  background: #f4f4f4 !important;
  .grant2 {
    width: 100%;
    // height: 100%;
    // height: 2670px;
    // border: 1px solid yellow;

    background: #f4f4f4 !important;
    .grant_W {
      width: 1320px;
      margin: 0 auto;
      display: flex;
      // border: 1px solid red;
      background: #f4f4f4;
      .Applic {
        // height: 1830px;
        background: #f4f4f4 !important;
        .title {
          margin-top: 125px;
          font-size: 60px;
          font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-weight: 900;
          color: #141414;
          span {
            color: #cf61dc;
          }
        }
        .contents {
          margin-top: 48px;
          font-size: 22px;
          font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
          font-weight: 400;
          color: #141414;
          word-spacing: -2px;
          .content2 {
            margin-top: 26px;
          }
        }
        .follows {
          margin-top: 140px;
          margin-bottom: 48px;
          font-size: 26px;
          font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
          font-weight: 400;
          color: #141414;
        }
        .followsbox {
          display: flex;
          .follows_l,
          .follows_r {
            width: 640px;
            height: 450px;
            background: #ffffff;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            margin-right: 40px;
            .folltitle {
              margin-top: 24px;
              margin-left: 24px;
              font-size: 22px;
              font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
              font-weight: 900;
              color: #141414;
              span {
                color: #cf61dc;
              }
            }
            .follcont_box {
              margin-top: 48px;
              margin-bottom: 40px;
              .follcont {
                height: 32px;
                line-height: 32px;
                margin-left: 24px;
                margin-bottom: 20px;
                font-size: 18px;
                font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
                font-weight: 400;
                color: rgba(20, 20, 20, 0.7);
                span {
                  color: #141414;
                }
              }
            }
          }
          .follows_l {
            .links {
              display: flex;
              justify-content: space-between;
              cursor: pointer;
              .linkst {
                height: 32px;
                font-size: 16px;
                font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
                font-weight: 500;
                color: #141414;
                line-height: 32px;
                margin-left: 24px;
                img {
                  width: 12px;
                  height: 12px;
                  margin-top: 9px;
                  margin-left: 4px;
                }
              }
              .follbtn {
                width: 111px;
                height: 42px;
                background: #cf61dc;
                border-radius: 237px 237px 237px 237px;
                opacity: 1;
                text-align: center;
                line-height: 36px;
                font-size: 18px;
                font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
                font-weight: 500;
                color: #ffffff;
                // margin-left: 505px;
                padding: 2px;
                // margin-top: 40px;
                cursor: pointer;
                margin-right: 24px;
              }
            }
          }
          .follows_r {
            width: 640px;
            height: 450px;
            background: #ffffff;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
          
            .links {
              display: flex;
              justify-content: space-between;
              cursor: pointer;
              .linkst {
                height: 32px;
                font-size: 16px;
                //color: red;
                font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
                font-weight: 500;
                color: #141414;
                line-height: 32px;
                margin-left: 24px;
                img {
                  width: 12px;
                  height: 12px;
                  margin-top: 9px;
                  margin-left: 4px;
                }
              }
              .follbtn {
                width: 149px;
                height: 42px;
                border-radius: 237px 237px 237px 237px;
                opacity: 1;
                border: 2px solid #a1a1a1;
                line-height: 32px;
                text-align: center;
                
                font-size: 16px;
                font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
                font-weight: 500;
                color: rgba(20, 20, 20, 0.4);
                padding: 2px;
                margin-right: 24px;
                
              }
            }
            // .follbtn {
            //   width: 149px;
            //   height: 42px;
            //   border-radius: 237px 237px 237px 237px;
            //   opacity: 1;
            //   border: 2px solid #a1a1a1;
            //   line-height: 32px;
            //   text-align: center;
            //   margin-left: 467px;
            //   font-size: 18px;
            //   font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
            //   font-weight: 500;
            //   color: rgba(20, 20, 20, 0.4);
            //   padding: 2px;
            //   margin-top: 40px;
            // }
          }
        }
        .email {
          font-size: 22px;
          font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
          font-weight: 400;
          color: rgba(20, 20, 20, 0.8);
          margin-top: 140px;
          span {
            color: #cf61dc;
          }
        }
        .email1 {
          font-size: 22px;
          font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
          font-weight: 500;
          color: rgba(20, 20, 20, 0.8);
          margin-top: 24px;
        }
        .email2 {
          font-size: 22px;
          font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
          font-weight: 400;
          color: rgba(20, 20, 20, 0.8);
          margin-top: 100px;
          word-spacing: -2px;
          margin-bottom: 100px;
        }
      }
    }
  }
}
</style>
